import { Injectable } from '@angular/core';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { IdentityService } from '../authentication/identity.service';
import { catchError, map, Observable, pipe, throwError } from 'rxjs';
import {
  GetTransportTypesPaginatedCommand,
  IGetTransportTypesPaginatedParameters,
  TransportTypePaginatedResponse,
} from './command/getTransportTypesPaginated.command';
import {
  ActiveTransportCommand,
  ISaveTransportCommandParameters,
} from './command/activeTrasportType.command';
import { SortTransportCommand } from './command/sortTransportType.command';
import {
  UpdateTransportTypeConfigCommand,
  IUpdateTransportTypeEditCommandParameters,
} from './command/updateTransportTypeConfig.command';
import { UploadTypeImgCommand, IUploadTypeImgCommandParameters } from './command/uploadTypeImg.command';
import { DeleteVehicleTypeImgCommand, IDeleteVehicleTypeImgCommandParameters } from './command/deleteVehicleTypeImg.command';
import { SortVehicleTypeImgCommand } from './command/sortVehicleTypeImg.command';
import {
  GetServicesTypesCommand,
  IGetServicesTypesCommandParameters,
} from './command/getServicesType.command';
import {
  UpdateActiveToServiceTypeCommand
} from './command/updateActiveToServicesType.command';
import {
  SortTypeServicesCommand
} from './command/sortTypeServices.command';
import {
  DeleteServiceTypeCommand
} from './command/deleteServiceType.command';
import {
  ResetServiceTypeCommand
} from './command/resetServiceType.command';
import {
  FindVehiclesByDomainContains,
  IFindVehiclesByDomainContainsClientsCommandParameters,
  IFindVehiclesByDomainContainsClientsResponse,
} from './command/findVehiclesByDomainContains.command';
import { SortEnum } from '../enum/sortEnum.enum';
import {
  AllDriversByVehicleIdResponseDTO,
  TransportTypeRequestDTO,
  VehicleGrid,
  VehicleRequestDTO,
  VehiclesResponse,
} from '../authentication/connection/interfaces/apiInterfaces';
import {
  GetVehiclesCommand,
  IGetVehiclesCommandParameters,
} from './command/getVehicles.command';
import {
  GetVehicleByIdCommand,
  IGetVehicleByIdCommandParameters,
} from './command/getVehicleById.command';
import {
  IUpdateVehicleCommandParameters,
  UpdateVehicleCommand,
} from './command/updateVehicle.command';
import {
  GetVehicleTypeByIdCommand,
  IGetVehicleTypeByIdCommandParameters,
} from './command/getVehicleTypeById.command';
import {
  GetDriversByVehicleIdCommand,
  IGetDriversByVehicleIdCommandParameters,
} from '../carrier/command/getDriversByVehicleId.command';
import { AddVehicleCommand, IAddVehicleCommandParameters } from './command/addVehicle.command';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class VehicleService {
  constructor(
    private _connectionService: ConnectionServices,
    // private _notificationsService: NotificationsService,
    // private _multiRegionService: MultiRegionService,
    private _identityService: IdentityService,
    private _translateService: TranslateService
  )
  { }

  public addVehicle(vehicle: VehicleRequestDTO): Observable<boolean> {
    const addVehicleCommand = new AddVehicleCommand();
    addVehicleCommand.setParameters(<IAddVehicleCommandParameters>{
      carrierUserId: vehicle.carrierUserId,
      documents: vehicle.documents,
      identificationCard: vehicle.identificationCard,
      characteristics: vehicle.characteristics,
      vehicleOwnerId: vehicle.vehicleOwnerId,
      photo: vehicle.photo,
      additionalTypes: vehicle.additionalTypes
    });
    return this._connectionService
      .Request(addVehicleCommand)
      .pipe(
        map((response) => {
          return true;
        }, error => {
          if (error.status === 409) {
            if ([
              'DOCUMENT_NOT_FOUND',
              'DOCUMENT_FIELD_NOT_FOUND',
              'DOCUMENT_FIELD_VALUE_UNIQUE',
              'INVALID_EXPIRATION_DATE'
            ].includes(error.error.errorCode)) {
              if (error.error.errorCode === 'DOCUMENT_FIELD_VALUE_UNIQUE') {
                let document: string = error.error.description.split('|')[0];
                let field: string = error.error.description.split('|')[1];
                let document_field: string = this._translateService.instant('carrier.documentation.types.' + document) + ' - ' + this._translateService.instant('carrier.documentation.field_types.' + field);
                let errorDesc: string = this._translateService.instant('carrier.documentation.server_errors.document_field_value_unique');
                // this._notificationsService.showInternalErrorMessage(
                //   'carrier.vehicles.title',
                //   document_field + ': ' + errorDesc
                // );
              } else {
                // this._notificationsService.showInternalErrorMessage(
                //   'carrier.vehicles.title',
                //   'carrier.documentation.server_errors.' + error.error.errorCode.toLowerCase()
                // );
              }
            } else {
              // this._notificationsService.showInternalErrorMessage(
              //   'carrier.vehicles.title',
              //   'carrier.vehicles.new_edit.server_errors.' + error.error.errorCode.toLowerCase()
              // );
            }
          } else {
            //this._notificationsService.showHttpErrorMessage('carrier.vehicles.title', error);
          }
          return false;
        })
      )
  }
  public getVehicles(
    carrier: string,
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    find?: string,
    enable?: string
  ): Observable<VehicleGrid> {
    const driverCommand = new GetVehiclesCommand();
    driverCommand.setParameters(<IGetVehiclesCommandParameters>{
      carrierUserId: carrier,
      column: column,
      page: page,
      size: size,
      sort: sort,
      find: find,
      enabled: enable,
    });
    return this._connectionService.Request(driverCommand).pipe(
      map((data) => {
        return data as VehicleGrid;
      }),
      catchError((error) => {
        return throwError(() => false);
      })
    );
  }
  //   public getVehiclesByCarrier(
  //     carrierUserId: string,
  //     vehicleType: string,
  //     domain: string
  //   ): Observable<VehiclesResponse[]> {
  //     const driverCommand = new GetVehiclesByCarrierCommand();
  //     driverCommand.setParameters(<IGetVehiclesByCarrierCommandParameters>{
  //       carrierUserId: carrierUserId,
  //       domain: domain,
  //       vehicleType: vehicleType
  //     });
  //     return this._connectionService
  //       .Request(driverCommand)
  //       .map(response => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage('vehicles', error);
  //         return Observable.throw(false);
  //       });
  //   }
  public findByDomainContains(
    terms: string
  ): Observable<IFindVehiclesByDomainContainsClientsResponse[]> {
    const clientCommand = new FindVehiclesByDomainContains();
    clientCommand.setParameters(<
      IFindVehiclesByDomainContainsClientsCommandParameters
      >{ terms: terms, carrierId: this._identityService.userId });
    return this._connectionService.Request(clientCommand).pipe(
      map((data) => {
        return data as any;
      }),
      catchError((error) => {
        //this._notificationsService.showHttpErrorMessage('clients', error);
        return throwError(false);
      })
    );
  }

  public getVehicleById(vehicleId: number): Observable<VehiclesResponse> {
    const command = new GetVehicleByIdCommand();
    command.setParameters(<IGetVehicleByIdCommandParameters>{
      vehicleId: vehicleId,
    });
    return this._connectionService.Request(command).pipe(
      map((data) => {
        return data as VehiclesResponse;
      }),
      catchError((error) => {
        return throwError(false);
      })
    );
  }

  //   public getVehicleICardById(vehicleId: number): Observable<VehicleICardResponseDTO> {
  //     const command = new GetVehicleICardByIdCommand();
  //     command.setParameters(<IGetVehicleByIdCommandParameters>{
  //       vehicleId: vehicleId
  //     });
  //     return this._connectionService
  //       .Request(command)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage('vehicles', error);
  //         return Observable.throw(false);
  //       });
  //   }

  public updateVehicle(
    vehicleId: number,
    vehicle: VehicleRequestDTO
  ): Observable<boolean> {
    let command = new UpdateVehicleCommand();
    command.setParameters(<IUpdateVehicleCommandParameters>{
      vehicleId: vehicleId,
      documents: vehicle.documents,
      carrierUserId: vehicle.carrierUserId,
      identificationCard: vehicle.identificationCard,
      characteristics: vehicle.characteristics,
      vehicleOwnerId: vehicle.vehicleOwnerId,
      photo: vehicle.photo,
      additionalTypes: vehicle.additionalTypes,
    });
    return this._connectionService.Request(command).pipe(
      map((response) => {
        return true;
      }),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
  //   }

  //   public addTransportType(
  //     transport: TransportTypeRequestDTO
  //   ): Observable<boolean> {
  //     const addTransportCommand = new AddTransportCommand();
  //     addTransportCommand.setParameters(transport);
  //     return this._connectionService
  //       .Request(addTransportCommand)
  //       .map(response => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.vehicle.type',
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return true;
  //       })
  //       .catch(error => {
  //         if (error.status === 409) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.vehicle.type',
  //             error.error.errorCode.toLowerCase()
  //           );
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.vehicle.type',
  //             error
  //           );
  //         }
  //         return Observable.throw(false);
  //       });
  //   }

  public getTransportType(
    vehicleTypeId: number
  ): Observable<TransportTypeRequestDTO> {
    const command = new GetVehicleTypeByIdCommand();
    command.setParameters(<IGetVehicleTypeByIdCommandParameters>{
      transportTypesId: vehicleTypeId,
    });
    return this._connectionService.Request(command).pipe(
      map((data) => {
        return data;
      }),
      catchError((error) => {
        return throwError(() => false);
      })
    );
  }

  //   public saveTransportType(
  //     transport: TransportTypeRequestDTO
  //   ): Observable<boolean> {
  //     const addTransportCommand = new SaveTransportCommand();
  //     addTransportCommand.setParameters(transport);
  //     return this._connectionService
  //       .Request(addTransportCommand)
  //       .map(response => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.vehicle.type',
  //           'toast.shared.message.successful_message_add'
  //         );
  //         return true;
  //       })
  //       .catch(error => {
  //         if (error.status === 409) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.vehicle.type',
  //             error.error.errorCode.toLowerCase()
  //           );
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.vehicle.type',
  //             error
  //           );
  //         }
  //         return Observable.throw(false);
  //       });
  //   }

  //   public activeTransportType(
  //     transport: TransportTypeActiveRequestDTO,
  //     carrierId,
  //     tranporTypeId
  //   ): Observable<boolean> {
  //     const activeTransportCommand = new ActiveTransportCommand();
  //     activeTransportCommand.setParameters({
  //       active: transport.active,
  //       carrierId: carrierId,
  //       transportTypesId: tranporTypeId,
  //       userId: +this._identityService.subUserId
  //     });
  //     return this._connectionService
  //       .Request(activeTransportCommand)
  //       .map(response => {
  //         if (transport.active) {
  //           this._notificationsService.showSuccessMessage(
  //             'toast.vehicle.type',
  //             'toast.vehicle.message.type_active'
  //           );
  //         } else {
  //           this._notificationsService.showSuccessMessage(
  //             'toast.vehicle.type',
  //             'toast.vehicle.message.type_deactive'
  //           );
  //         }
  //         return true;
  //       })
  //       .catch(error => {
  //         console.log('error',error)
  //         if (error.status === 409) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.vehicle.type',
  //             error.error.errorCode.toLowerCase()
  //           );
  //         } else if (error.status === 404) {
  //           if(error.error.errorCode == 'CARRIER_RATE_WITH_TRANSPORT_TYPE'){

  //             this._notificationsService.showErrorMessage(
  //               this._translateService.instant('toast.vehicle.type'),
  //               this._translateService.instant('toast.vehicle.error_code.CARRIER_RATE_WITH_TRANSPORT_TYPE',{carrierRates:error.error.description})
  //             );
  //           } else {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.vehicle.type',
  //               'toast.vehicle.error_code.type_in_use'
  //             );
  //           }
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.vehicle.type',
  //             error
  //           );
  //         }
  //         return Observable.throw(false);
  //       });
  //   }

  //   public getTransportTypeClusters(): Observable<TransportTypeClusterDTO[]> {
  //     const command = new GetTransportTypeClustersCommand();
  //     return this._connectionService
  //       .Request(command)
  //       .map(data => {
  //         return data;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.vehicle.cluster',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   sortVehicles(sortedIds: any[]): Observable<void> {
  //     let command = new SortTransportCommand();
  //     sortedIds.push(this._identityService.userId);
  //     command.setParameters(sortedIds);

  //     return this._connectionService
  //       .Request(command)
  //       .map(response => {})
  //       .catch(error => {
  //         return Observable.throw(false);
  //       });
  //   }

  //   getVehicleInfoDashboard(
  //     carrierUserId: any,
  //     driverId: any,
  //   ) {
  //     const command = new GetVehicleDashboardByIdCommand();
  //     command.setParameters(<
  //       IGetVehicleDashboardByIdCommandParameters
  //       >{
  //         carrierUserId: carrierUserId,
  //         driverId: driverId,
  //       });
  //     return this._connectionService
  //       .Request(command)
  //       .map(response => {
  //         return response;
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.shared.error_code.0',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  public getDriversByVehicle(carrierUserId: any, vehicleId: any): Observable<AllDriversByVehicleIdResponseDTO[]> {
    const command = new GetDriversByVehicleIdCommand();
    const parameters: IGetDriversByVehicleIdCommandParameters = {
      carrierId: carrierUserId,
      vehicleId: vehicleId,
    };
    command.setParameters(parameters);
    return this._connectionService.Request(command).pipe(
      map((data) => {
        return data as unknown as AllDriversByVehicleIdResponseDTO[];
      }),
      catchError((error) => {
        return throwError(() => false);
      })
    );
  }

  //   public postAutomaticSurrender(
  //     vehicleId: any,
  //     carrierUserId: any
  //   ) {
  //     const command = new PostAutomaticSurrenderCommand();
  //     const parameters : IPostAutomaticSurrenderCommandParameters = {
  //       vehicleId: vehicleId,
  //       carrierUserId: carrierUserId,
  //     }
  //     command.setParameters(parameters);
  //     return this._connectionService
  //       .Request(command)
  //       .map(response => {
  //         return Observable.throw(true);
  //       })
  //       .catch(error => {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.shared.error_code.0',
  //           error
  //         );
  //         return Observable.throw(false);
  //       });
  //   }

  //   public updateTransportTypeConfig(
  //     carrierId,
  //     config: IEditTransportTypes
  //   ): Observable<boolean> {
  //     const updTransportTypeConfigCommand = new UpdateTransportTypeConfigCommand();
  //     updTransportTypeConfigCommand.setParameters({
  //       carrierId: carrierId,
  //       transportTypesId: config.transportTypeId.toString(),
  //       name: config.visibleName,
  //       description: config.description
  //     });
  //     return this._connectionService
  //       .Request(updTransportTypeConfigCommand)
  //       .map(response => {
  //         this._notificationsService.showSuccessMessage(
  //           'toast.vehicle.type',
  //           'toast.vehicle.message.config_upd'
  //         );
  //         return true;
  //       })
  //       .catch(error => {
  //         if (error.status === 409) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.vehicle.type',
  //             error.error.errorCode.toLowerCase()
  //           );
  //         } else if (error.status === 404) {
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.vehicle.type',
  //             'toast.vehicle.error_code.type_in_use'
  //           );
  //         } else {
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.vehicle.type',
  //             error
  //           );
  //         }
  //         return Observable.throw(false);
  //       });
  //   }

  //   uploadVehicleTypeImg(imgBase64: string, order: number, transportTypeId: number) {
  //     let command = new UploadTypeImgCommand();

  //     command.setParameters({
  //       carrierId: this._identityService.userId,
  //       imageBase64: imgBase64,
  //       order: order,
  //       transportTypeId: transportTypeId
  //     });

  //     return this._connectionService
  //       .Request(command)
  //       .map(response => response)
  //       .catch(error => {
  //         return Observable.throw(false);
  //       });
  //   }

  //   deleteVehicleTypeImg(imageId: number, transportTypeId: number) {
  //     let command = new DeleteVehicleTypeImgCommand();

  //     command.setParameters({
  //       carrierId: this._identityService.userId,
  //       transportTypeId: transportTypeId,
  //       imgId: imageId
  //     });

  //     return this._connectionService
  //       .Request(command)
  //       .map(response => {})
  //       .catch(error => {
  //         return Observable.throw(false);
  //       });
  //   }

  //   sortVehicleTypeImg(img: number[], transportTypeId: number) {
  //     let command = new SortVehicleTypeImgCommand();
  //     command.setUrlParameters(this._identityService.userId, transportTypeId);
  //     command.setParameters(img);

  //     return this._connectionService
  //       .Request(command)
  //       .map(response => {})
  //       .catch(error => {
  //         return Observable.throw(false);
  //       });
  //   }

  getServicesTypes(userId = this._identityService.userId, contractorAccountId: number = null): Observable<any> {
    let command = new GetServicesTypesCommand();
    command.setParameters({
      carrierId: userId,
      contractorAccountId,
    });

    return this._connectionService.Request(command).pipe(map((response) => response),
      catchError((error) => throwError(() => false)));
  }

  getServicesTypesByFilter(request: IGetServicesTypesCommandParameters): Observable<any> {
    let command = new GetServicesTypesCommand();
    command.setParameters(request);

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as any;
        }),
        catchError(() => {
          return throwError(() => false);
        }));
  }

  updateActiveToServicesType(serviceTypeId: number, active: boolean) {
    let command = new UpdateActiveToServiceTypeCommand();
    command.setUrlParameters(this._identityService.userId, serviceTypeId);
    command.setParameters({
      active: active,
      userId: +this._identityService.subUserId
    });

    return this._connectionService.Request(command).pipe(map((response) => response),
      catchError((error) => throwError(() => false)));
  }

  sortTypeServices(ids: number[]) {
    let command = new SortTypeServicesCommand();
    command.setUrlParameters(this._identityService.userId);
    command.setParameters(ids);

    return this._connectionService
      .Request(command)
      .pipe(map(response => { }),
        catchError(error => {
          return throwError(() => false);
        }));
  }

  deleteServiceType(id: number) {
    let command = new DeleteServiceTypeCommand();
    command.setUrlParameters(this._identityService.userId, id);
    command.setParameters({
      userId: +this._identityService.subUserId
    });

    return this._connectionService.Request(command).pipe(map((response) => response),
      catchError((error) => throwError(() => false)));
  }

  resetServicesType(serviceTypeId: number) {
    let command = new ResetServiceTypeCommand();
    command.setUrlParameters(this._identityService.userId);
    command.setParameters({
      serviceTypeId: serviceTypeId,
      userId: +this._identityService.subUserId
    });

    return this._connectionService.Request(command).pipe(map((response) => response),
      catchError((error) => throwError(() => false)));
  }

  // Transport Types methods (MX-5627)

  getTransportTypesPaginated(
    page: number = 0,
    size: number = 20,
    column?: string,
    sort?: string,
    find?: string
  ): Observable<TransportTypePaginatedResponse> {
    const command = new GetTransportTypesPaginatedCommand();
    command.setParameters(<IGetTransportTypesPaginatedParameters>{
      carrierId: this._identityService.userId,
      page,
      size,
      column,
      sort,
      find,
    });
    return this._connectionService.Request(command).pipe(
      map((data) => data as unknown as TransportTypePaginatedResponse),
      catchError((error) => throwError(() => error))
    );
  }

  activeTransportType(transportTypeId: number, active: boolean): Observable<boolean> {
    const command = new ActiveTransportCommand();
    command.setParameters(<ISaveTransportCommandParameters>{
      active,
      carrierId: this._identityService.userId,
      transportTypesId: transportTypeId.toString(),
      userId: +this._identityService.subUserId,
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => throwError(() => error))
    );
  }

  sortTransportTypes(ids: number[]): Observable<void> {
    const command = new SortTransportCommand();
    // Append carrierId to array as required by the command (v1 pattern preserved)
    const payload = [...ids, this._identityService.userId];
    command.setParameters(payload);
    return this._connectionService.Request(command).pipe(
      map(() => undefined),
      catchError((error) => throwError(() => error))
    );
  }

  updateTransportTypeConfig(
    transportTypeId: number,
    visibleName: string,
    description: string
  ): Observable<boolean> {
    const command = new UpdateTransportTypeConfigCommand();
    command.setParameters(<IUpdateTransportTypeEditCommandParameters>{
      carrierId: this._identityService.userId,
      transportTypesId: transportTypeId.toString(),
      name: visibleName,
      description,
    });
    return this._connectionService.Request(command).pipe(
      map(() => true),
      catchError((error) => throwError(() => error))
    );
  }

  uploadVehicleTypeImg(
    imageBase64: string,
    order: number,
    transportTypeId: number
  ): Observable<number> {
    const command = new UploadTypeImgCommand();
    command.setParameters(<IUploadTypeImgCommandParameters>{
      carrierId: this._identityService.userId,
      imageBase64,
      order,
      transportTypeId,
    });
    return this._connectionService.Request(command).pipe(
      map((response) => response as unknown as number),
      catchError((error) => throwError(() => error))
    );
  }

  deleteVehicleTypeImg(imgId: number, transportTypeId: number): Observable<void> {
    const command = new DeleteVehicleTypeImgCommand();
    command.setParameters(<IDeleteVehicleTypeImgCommandParameters>{
      carrierId: this._identityService.userId,
      transportTypeId,
      imgId,
    });
    return this._connectionService.Request(command).pipe(
      map(() => undefined),
      catchError((error) => throwError(() => error))
    );
  }

  sortVehicleTypeImg(imgIds: (number | null)[], transportTypeId: number): Observable<void> {
    const command = new SortVehicleTypeImgCommand();
    command.setUrlParameters(this._identityService.userId, transportTypeId);
    command.setParameters(imgIds);
    return this._connectionService.Request(command).pipe(
      map(() => undefined),
      catchError((error) => throwError(() => error))
    );
  }
}
